import { render, staticRenderFns } from "./PopularBadge.vue?vue&type=template&id=3d6d3564"
import script from "./PopularBadge.vue?vue&type=script&lang=js"
export * from "./PopularBadge.vue?vue&type=script&lang=js"
import style0 from "./PopularBadge.vue?vue&type=style&index=0&id=3d6d3564&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports